import React, { createContext, useState, useEffect, useContext,} from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../../AuthContext";
import { far } from "@fortawesome/free-regular-svg-icons";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const baseUrl=process.env.REACT_APP_SECOND_BACKEND_URL;
  const [allHotels, setAllHotels] = useState([]);//to hold the values of all hotels in state
  const [hotelToEdit, setHotelToEdit] = useState(null);//Used to determine whether the request is a post or a patch
  
  const [adminData,setAdminData]=useState({
    username:"",
    profile:"",
    name:"",
    id:0,
    email:"",
    role:""
  })
  const [allBanks, setAllBanks] = useState([]);//Holds the values of all banks in state
  const [bankToEdit, setBankToEdit] = useState(null);//Used to determine whether the request for a bank is the post or the patch

  const [allTransporters, setAllTransporters] = useState([]);//Used to hold the value transporting companies in state
  const [transporterToEdit, setTransporterToEdit] = useState(null);//Used to determine whether the request for atransporting company is the post or the patch
 
   const [currentPage, setCurrentPage] = useState(1);//Sets the currentPage for a user incase there is pagination
  const [postsPerPage, setPostPerPage] = useState(4);  //Used to determine the number of posts that shuold appear when there is pagination
  let indexOfLastPost = (currentPage * postsPerPage)
  let indexOfFirstPost = indexOfLastPost - postsPerPage

  // States fo holding the other users for communication
  const [allBankOwners,setAllBankOwners]=useState([])
  const [allCustomers,setAllCustomers]=useState([])
  const [allFarmers,setAllFarmers]=useState([])
  const [allHotelOwners,setAllHotelOwners]=useState([])
  const [allTransportOwners,setAllTransportOwners]=useState([])
 
  const { token } = useContext(AuthContext); 
  
  const hotelUrl = `${baseUrl}/hotels`
  const bankUrl = `${baseUrl}/banks`;
  const transporterUrl = `${baseUrl}/transporters`;

  const navigate = useNavigate();
  // Run this useEffect when the token changes
  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
     const {role,name,username,id,profile,email}=decodedToken?.sub
        
      if (role !== "admin") {
        navigate("/unauthorised");
        return;
      } 
      setAdminData(prevData=>(
        {
          ...prevData,
          username:username?username:prevData?.username,
          name:name?name:prevData?.name,
          profile:profile?profile:"",
          id:id?id:prevData?.id,
          email:email?email:prevData?.email,
          role:role?role:prevData?.role
        }
      ))            
    }
    else{
      navigate("/loginUser")
      return;
    }
  }, [token]);



  // useEffect(() => {
  //   fetchAdminHotels();
  // }, []);

  // useEffect(()=>{
  //   fetchAdminBanks()
  // },[])

  // useEffect(()=>{
  // fetchAdminTransporters()
  // },[])
useEffect(()=>{
  fetchaAllData()
},[])
  // Function to fetch Hotels,Transporters and  Banks
  const fetchaAllData=async()=>{
    try {
      const res=await fetch(`${baseUrl}/admin_needed_data`)
      const data=await res.json();
  
      if(data.AllBanks.length>0){
        setAllBanks(data.AllBanks)
        const allBankOwners=data.AllBanks.flatMap(bank=>bank.owners);     
       
        if(allBankOwners.length>0){
          const uniqueBankOwners=[...new Set(allBankOwners.map(bo=>bo.username))].map(username=>allBankOwners.find(bo=>bo.username===username))
          setAllBankOwners(uniqueBankOwners)
        }     
       
      }
      if(data.AllHotels.length>0){
        setAllHotels(data.AllHotels)
        const newHotelOwners=data.AllHotels.flatMap(ho=>ho.owners)
        if(newHotelOwners.length>0){
         const uniqueHotelOwners=[...new Set(newHotelOwners.map(ho=>ho.username))].map(username=>newHotelOwners.find(ho=>ho.username===username));
          setAllHotelOwners(uniqueHotelOwners)          
        }    

      }
      if(data.AllTransporters.length>0){
        setAllTransporters(data.AllTransporters)
        const allTransportOwners=data.AllTransporters.flatMap(to=>to.owners)
        if(allTransportOwners.length>0){
          const uniqueTransOwners=[...new Set(allTransportOwners.map(to=>to.username))].map(username=>allTransportOwners.find(to=>to.username===username))
          setAllTransportOwners(uniqueTransOwners)
        }        
      }
      if(data.AllCustomers.length>0){
        const uniqueCustomers=[...new Set(data?.AllCustomers.map(customer=>customer.username))].map(username=>data?.AllCustomers.find(customer=>customer.username===username));
        setAllCustomers(uniqueCustomers);
      }
      if(data.AllFarmers.length>0){
        const uniqueFarmers=[...new Set(data?.AllFarmers.map(farmer=>farmer.username))].map(username=>data?.AllFarmers.find(farmer=>farmer.username===username));
        setAllFarmers(uniqueFarmers);        
      }
      
    } catch (error) {
      console.error(`An error ocurred fetching all the data ${error}`)
    }
  }
  //Function for fetching hotels
  const fetchAdminHotels = async () => {
    try {
      const res = await fetch(hotelUrl);
      const data=await res.json()
      setAllHotels(data)
      let newHotelOwners=data.flatMap(hotel=>hotel?.Owners)
      if(newHotelOwners?.length>0){
        let uniqueHotelOwner=[...new Set(newHotelOwners.map(ho=>ho.username))].map(username=>newHotelOwners.find(hotelOwner=>hotelOwner?.username===username))
        setAllHotelOwners(uniqueHotelOwner)
      }     
    } catch (error) {
       console.error(`An ocurred  fetching hotels ${error}`)
    }
  };

  // Function for adding hotels
  const addAdminHotel = async (newHotel) => {
    try {
      const res = await fetch(hotelUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(newHotel),
      });      
      if (res.ok) {       
        setAllHotels([...allHotels, newHotel]);
        alert(`${newHotel.name} added successfully`);
       await fetchAdminHotels();       
      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
          return;
        }
        else{
          const result=await res.json()
        alert(`An error occurred adding hotel : ${result?.Error || result?.Message}`) ;
        
        }
      }
    } catch (error) {
      console.error(`Error adding Hotels ${error}`);
    }
  };

  // Function to delete a hotel
  const deleteAdminHotel = async (hotelInfo) => {
    try{
      if (!window.confirm(`Are you sure you want to delete ${hotelInfo.name} `)) return;
    const res = await fetch(`${baseUrl}/hotels/${hotelInfo.id}`, {
      method: "DELETE",
    });
    if (res.ok) {
      const filteredHotels=allHotels.filter(hotel=>hotel?.id!==hotelInfo.id)
      setAllHotels(filteredHotels);
      alert("Hotel deleted successfully");
     await  fetchAdminHotels();     
    } else {
      if(res.status===500){
        alert("An error ocurred . please try again")
      }
      else{
        const result=await res.json()
   alert(`An error occurred deleting hotel : ${result?.Error || result?.Message}`)
      }
    }
    }
    catch(error){
      console.error("Error deleting hotels",error)
    }
    
  };
  
  // Function to edit  a hotel
  const updateAdminHotel = async (hotelInfo) => {
    try {
      const res = await fetch(`${hotelUrl}/${hotelInfo.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${token}`
        },
        body: JSON.stringify(hotelInfo)
      });     
      if (res.ok) {
        alert(`Hotel ${hotelInfo.name} updated successfully`);
       await fetchAdminHotels();
      } else { 
        if(res.status===500){
          alert("An error ocurred .please try again");
        }
        else{
          const result=await res.json()
         alert(`An error occurred updating  hotel : ${result?.Error || result?.Message}`)
        }
      }
    } catch (error) {     
      console.error(`Error updating hotel ${error}`);
    }
  };

  const editHotel = (hotel) => {
    setHotelToEdit(hotel)
  }

  
  
  async function fetchAdminBanks() {
    try {
      const res = await fetch(bankUrl);
      const data = await res.json();
      setAllBanks(data);
      // console.log(`Allbanks data`,data)
      let newBankOwners=data.flatMap(bank=>bank.owners)
      if(newBankOwners.length>0){
        let uniqueBankOwners=[...new Set(newBankOwners.map(bo=>bo.username))].map(username=>newBankOwners.find(bo=>bo.username===username))
        setAllBankOwners(uniqueBankOwners)
      }
     
    } catch (error) {
      console.error(`Error fetching banks ${error}`);
    }
  }
  // Posting a bank
  async function addAdminBank(newBank) {
    try {
      const res = await fetch(`${bankUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${token}`
        },
        body: JSON.stringify(newBank),
      });      
      if (res.ok) {
        setAllBanks([...allBanks, newBank]);
        alert(`${newBank.name} added successfully`);
       await fetchAdminBanks();        
      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
        }
        else{
          const result=await res.json()
           alert(`An error occurred adding banks : ${result.Error || result.Message}`)
        }
      }
    } catch (error) {
      console.error(`Error adding banks ${error}`);
    }
  }

  // Function to delete a bank
  async function deleteAdminBank(newBank) {
    try{
      if (!window.confirm(`Are you sure you want to delete ${newBank.name}`)) return
    else {
      const res = await fetch(`${baseUrl}/banks/${newBank.id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        const remBanks = allBanks.filter((bank) => bank.id !== newBank.id);
        setAllBanks(remBanks);
        alert(`${newBank.name}deleted successfully`);
      await  fetchAdminBanks()
      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
        }
        else{
          const result=await res.json()
     alert(`An error occurred deleting  bank : ${result.Error || result.Message}`)
        }
      }
    }
    }
    catch(error){
     console.error(`An error occurred deleting bank ${error}`)
    }
  }

  async function updateAdminBank(bankInfo) {
    try {
      const res = await fetch(`${baseUrl}/banks/${bankInfo.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${token}`
        },
        body: JSON.stringify(bankInfo),
      });
      
      if (res.ok) {
        alert(`Bank ${bankInfo.name} updated successfully`);
         await fetchAdminBanks();
      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
        }
        else{
          const result=await res.json()
     alert(`An error occurred updating bank: ${result.Error || result.Message}`)
        }
      }
    } catch (error) {
      console.error(`Error updating hotel ${error}`);
    }
  }

  const editBank = (bank) => {
    // Sets bank to edit to the given bank
    setBankToEdit(bank)
  }

  
  async function fetchAdminTransporters() {
    try {
      const res = await fetch(transporterUrl);
      const data = await res.json();
      setAllTransporters(data);
      let newTransportOwners=data.flatMap(transOwner=>transOwner?.Owners)
      // console.log("newTransportOwners",newTransportOwners)
      if(newTransportOwners.length>0){
        let uniqueTransOwners=[...new Set(newTransportOwners.map(transOwner=>transOwner.username))].map(username=>newTransportOwners.find(transOwner=>transOwner.username===username))
           setAllTransportOwners(uniqueTransOwners)        
      }
    } catch (error) {
      console.error(`An error ocurred fetching transporters ,${error}`);
    }
  }
  // Posting a transporter
  async function addAdminTransporter(newtransporter) {
    try {
      const res = await fetch(transporterUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${token}`
        },
        body: JSON.stringify(newtransporter),
      });
      if (res.ok) {
        setAllTransporters([...allTransporters, newtransporter]);
        alert(`${newtransporter.name} added successfully`);
        await fetchAdminTransporters();

      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
        }
        else{
          const result=await res.json()
     alert(`An error occurred adding transporter : ${result.Error || result.Message}`)
        }
      }
    } catch (error) {
      console.error(`An error adding transpoter ${error}`);
    }
  }

  // Function to delete a bank
  async function deleteAdminTransporter(transporterInfo) {
    try{
      if (!window.confirm(`Are you sure you want to delete ${transporterInfo.name}`)) return
    else {
      const res = await fetch(`${transporterUrl}/${transporterInfo.id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        const remTransporters = allTransporters.filter((transporter) => transporter.id !== transporterInfo.id);
        setAllTransporters(remTransporters);
        alert(`${transporterInfo.name} deleted successfully`);
     await  fetchAdminTransporters()
      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
        }
        else{
          const result=await res.json()
     alert(`An error occured deleting transporter : ${result.Error || result.Message}`)
        }
      }
    }
    }
    catch(error){
      console.error(`An error ocuurred deleting transporter ${error}`)
    }
  }
  async function updateAdminTransporter(transporterInfo) {
    try {
      const res = await fetch(`${transporterUrl}/${transporterInfo.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${token}`
        },
        body: JSON.stringify(transporterInfo),
      });
      if (res.ok) {
        alert(`Transporter ${transporterInfo.name} updated successfully`);
       await fetchAdminTransporters();
      } else {
        if(res.status===500){
          alert("An error ocurred .please try again")
        }
        else{
          const result=await res.json()
          alert(`An error occurred updating transporter : ${result.Error || result.Message}`)
        }
      }
    } catch (error) {
      console.error(`Error updating hotel ${error}`);
    }
  }

  // Function to set the transporter to be edited
  const editTransporter = (Transporter) => {
    setTransporterToEdit(Transporter)
  }
  // Function to set the current page to the page  that a user clicks
  const paginate = (number) => {
    setCurrentPage(number);
  };

  
  const handleSendMessage = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/messages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(values)
      })
      if (res.ok) {
        // handleSendMessage()
      }
    } catch (error) {
      console.error(`Error sending message ${error}`)
    }
    
 }
  let newHotelData = allHotels.length > 4 ? allHotels.slice(indexOfFirstPost, indexOfLastPost) : allHotels
  let newBanksData = allBanks.length > 4 ? allBanks.slice(indexOfFirstPost, indexOfLastPost) : allBanks
  let newTransportersData = allTransporters.length > 4 ? allTransporters.slice(indexOfFirstPost, indexOfLastPost) : allTransporters

  const contextValue = {
    allBankOwners,allCustomers,allFarmers,allHotelOwners,allTransportOwners,
   
    baseUrl,adminData,
    // Hotels functionality
    allHotels, hotelToEdit, setHotelToEdit, addAdminHotel, deleteAdminHotel, updateAdminHotel, editHotel, newHotelData,

    // Banks functionality
    allBanks, addAdminBank, updateAdminBank, deleteAdminBank, editBank, bankToEdit, setBankToEdit, newBanksData,
    // Transporters functionality
    allTransporters, addAdminTransporter, updateAdminTransporter, deleteAdminTransporter, editTransporter, transporterToEdit, setTransporterToEdit,
    // For users in the app
    newTransportersData,
    paginate,
    currentPage,
    postsPerPage,    
    hotelUrl,
    bankUrl, indexOfFirstPost, indexOfLastPost,
    transporterUrl, handleSendMessage, setPostPerPage,token,setAllFarmers,setAllCustomers,allCustomers

  };

  return (
    <AdminContext.Provider value={contextValue}>
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContext;
